import live_streaming_holiday_season_theme from '@anm/data/video-templates/pages/live-streaming-holiday_season-theme';
import live_streaming_festive_theme from '@anm/data/video-templates/pages/live_streaming_festive_theme';
import live_streaming_gradient_theme from '@anm/data/video-templates/pages/live_streaming_gradient_theme';
import live_streaming_old_hollywood_theme from '@anm/data/video-templates/pages/live_streaming_old_hollywood_theme';
import live_streaming_poinsettia_theme from '@anm/data/video-templates/pages/live_streaming_poinsettia_theme';
import ads_promo from './ads-promo';
import ads_promo_ads from './ads-promo-ads';
import ads_promo_promo from './ads-promo-promo';
import ads_promo_testimonials from './ads-promo-testimonials';
import all_templates from './all-templates';
import holidays from './holidays';
import holidays_back_to_school from './holidays-back-to-school';
import holidays_birthday from './holidays-birthday';
import holidays_black_friday_cyber_monday from './holidays-black-friday-cyber-monday';
import holidays_christmas from './holidays-christmas';
import holidays_easter from './holidays-easter';
import holidays_fathers_day from './holidays-fathers-day';
import holidays_halloween from './holidays-halloween';
import holidays_independence_day from './holidays-independence-day';
import holidays_labor_day from './holidays-labor-day';
import holidays_memorial_day from './holidays-memorial-day';
import holidays_mothers_day from './holidays-mothers-day';
import holidays_observances from './holidays-observances';
import holidays_season from './holidays-season';
import holidays_st_patricks_day from './holidays-st-patricks-day';
import holidays_thanksgiving from './holidays-thanksgiving';
import holidays_valentines_day from './holidays-valentines-day';
import image from './image';
import image_facebook_cover from './image-facebook-cover';
import image_lower_third from './image-lower-third';
import image_meme from './image-meme';
import image_quote from './image-quote';
import image_thumbnail from './image-thumbnail';
import image_overlay from './image-overlay';
import industry from './industry';
import industry_architecture_and_design from './industry-architecture-and-design';
import industry_art_and_culture from './industry-art-and-culture';
import industry_beauty from './industry-beauty';
import industry_business from './industry-business';
import industry_e_commerce from './industry-e-commerce';
import industry_education from './industry-education';
import industry_entertainment from './industry-entertainment';
import industry_fashion from './industry-fashion';
import industry_food from './industry-food';
import industry_healthcare from './industry-healthcare';
import industry_lifestyle from './industry-lifestyle';
import industry_marketing from './industry-marketing';
import industry_music from './industry-music';
import industry_nature from './industry-nature';
import industry_pets from './industry-pets';
import industry_real_estate from './industry-real-estate';
import industry_sports_and_fitness from './industry-sports-and-fitness';
import industry_technology from './industry-technology';
import industry_travel from './industry-travel';
import industry_video_game from './industry-video-game';
import industry_wedding from './industry-wedding';
import live_streaming from './live-streaming';
import live_streaming_acid_pastel_theme from './live-streaming-acid-pastel-theme';
import live_streaming_black_star_theme from './live-streaming-black-star-theme';
import live_streaming_brb_screens from './live-streaming-brb-screens';
import live_streaming_coffee_theme from './live-streaming-coffee-theme';
import live_streaming_color_bars_theme from './live-streaming-color-bars-theme';
import live_streaming_countdown from './live-streaming-countdown';
import live_streaming_dark_peach_theme from './live-streaming-dark-peach-theme';
import live_streaming_emerald_theme from './live-streaming-emerald-theme';
import live_streaming_frame_overlay from './live-streaming-frame-overlay';
import live_streaming_geometric_theme from './live-streaming-geometric-theme';
import live_streaming_honeycomb_theme from './live-streaming-honeycomb-theme';
import live_streaming_intro from './live-streaming-intro';
import live_streaming_key_takeaway from './live-streaming-key-takeaway';
import live_streaming_linkedin_remastered_theme from './live-streaming-linkedin-remastered-theme';
import live_streaming_nature_theme from './live-streaming-nature-theme';
import live_streaming_neon_smoke_theme from './live-streaming-neon-smoke-theme';
import live_streaming_ended_screen from './live-streaming-ended-screen';
import live_streaming_promo from './live-streaming-promo';
import live_streaming_qa from './live-streaming-qa';
import live_streaming_smd_summit_theme from './live-streaming-smd-summit-theme';
import live_streaming_spiritual_theme from './live-streaming-spiritual-theme';
import live_streaming_starting_soon from './live-streaming-starting-soon';
import live_streaming_subtle_bw_theme from './live-streaming-subtle-bw-theme';
import live_streaming_tech_diffs_screens from './live-streaming-tech-diffs-screens';
import live_streaming_thumbnails from './live-streaming-thumbnails';
import live_streaming_trn_lower_third from './live-streaming-trn-lower-third';
import live_streaming_us_theme from './live-streaming-us-theme';
import live_streaming_valentine_theme from './live-streaming-valentine-theme';
import live_streaming_wave_video_theme from './live-streaming-wave-video-theme';
import live_streaming_yogurt_theme from './live-streaming-yogurt-theme';
import live_streaming_cooking_show_theme from './live-streaming-cooking-show-theme';
import live_streaming_gradient_business_theme from './live-streaming-gradient-business-theme';
import live_streaming_night_city_theme from './live-streaming-night-city-theme';
import live_streaming_fitness_theme from './live-streaming-fitness-theme';
import live_streaming_remote_work_theme from './live-streaming-remote-work-theme';
import live_streaming_medical_theme from './live-streaming-medical-theme';
import live_streaming_makeup_theme from './live-streaming-makeup-theme';
import live_streaming_interior_design_theme from './live-streaming-interior-design-theme';
import live_streaming_halloween_theme from './live-streaming-halloween-theme';
import live_streaming_thanksgiving_theme from './live-streaming-thanksgiving-theme';
import live_streaming_christmas_sweater_theme from './live-streaming-christmas-sweater-theme';
import main from './main';
import popular from './popular';
import search from './search';
import social_media from './social-media';
import social_media_facebook from './social-media-facebook';
import social_media_youtube_shorts from './social-media-youtube-shorts';
import social_media_instagram from './social-media-instagram';
import social_media_linkedin from './social-media-linkedin';
import social_media_pinterest from './social-media-pinterest';
import social_media_stories from './social-media-stories';
import social_media_trending_hashtags from './social-media-trending-hashtags';
import social_media_twitter from './social-media-twitter';
import social_media_youtube from './social-media-youtube';
import social_media_tiktok from './social-media-tiktok';
import trending from './trending';
import use_cases from './use-cases';
import use_cases_animated from './use-cases-animated';
import use_cases_background_video from './use-cases-background-video';
import use_cases_blog_promotion from './use-cases-blog-promotion';
import use_cases_collage from './use-cases-collage';
import use_cases_countdown from './use-cases-countdown';
import use_cases_event_promotion from './use-cases-event-promotion';
import use_cases_frame from './use-cases-frame';
import use_cases_fun_social_posts from './use-cases-fun-social-posts';
import use_cases_greetings from './use-cases-greetings';
import use_cases_intro_outro from './use-cases-intro-outro';
import use_cases_listicles from './use-cases-listicles';
import use_cases_lower_third from './use-cases-lower-third';
import use_cases_lyric from './use-cases-lyric';
import use_cases_memes from './use-cases-memes';
import use_cases_news from './use-cases-news';
import use_cases_podcast_promotion from './use-cases-podcast-promotion';
import use_cases_powerpoint from './use-cases-powerpoint';
import use_cases_presentation from './use-cases-presentation';
import use_cases_product_demo from './use-cases-product-demo';
import use_cases_quotes from './use-cases-quotes';
import use_cases_recipe from './use-cases-recipe';
import use_cases_restaurant_promo from './use-cases-restaurant-promo';
import use_cases_slideshow from './use-cases-slideshow';
import use_cases_special_offers from './use-cases-special-offers';
import use_cases_travel_vlog from './use-cases-travel-vlog';
import use_cases_tutorials from './use-cases-tutorials';
import use_cases_website_video from './use-cases-website-video';
import use_cases_zoom_backgrounds from './use-cases-zoom-backgrounds';
import use_cases_trailers from './use-cases-trailers';

export * from './types';

const allPages = {
  main,
  search,
  popular,
  industry,
  trending,
  holidays,
  'all-templates': all_templates,
  'live-streaming': live_streaming,
  'live-streaming-promo': live_streaming_promo,
  'live-streaming-intro': live_streaming_intro,
  'live-streaming-ended-screen': live_streaming_ended_screen,
  'live-streaming-us-theme': live_streaming_us_theme,
  'live-streaming-countdown': live_streaming_countdown,
  'live-streaming-thumbnails': live_streaming_thumbnails,
  'live-streaming-brb-screens': live_streaming_brb_screens,
  'live-streaming-nature-theme': live_streaming_nature_theme,
  'live-streaming-coffee-theme': live_streaming_coffee_theme,
  'live-streaming-yogurt-theme': live_streaming_yogurt_theme,
  'live-streaming-emerald-theme': live_streaming_emerald_theme,
  'live-streaming-honeycomb-theme': live_streaming_honeycomb_theme,
  'live-streaming-subtle-bw-theme': live_streaming_subtle_bw_theme,
  'live-streaming-spiritual-theme': live_streaming_spiritual_theme,
  'live-streaming-geometric-theme': live_streaming_geometric_theme,
  'live-streaming-trn-lower-third': live_streaming_trn_lower_third,
  'live-streaming-neon-smoke-theme': live_streaming_neon_smoke_theme,
  'live-streaming-smd-summit-theme': live_streaming_smd_summit_theme,
  'live-streaming-wave-video-theme': live_streaming_wave_video_theme,
  'live-streaming-color-bars-theme': live_streaming_color_bars_theme,
  'live-streaming-black-star-theme': live_streaming_black_star_theme,
  'live-streaming-dark-peach-theme': live_streaming_dark_peach_theme,
  'live-streaming-acid-pastel-theme': live_streaming_acid_pastel_theme,
  'live-streaming-tech-diffs-screens': live_streaming_tech_diffs_screens,
  'live-streaming-linkedin-remastered-theme': live_streaming_linkedin_remastered_theme,
  'live-streaming-holiday-season-theme': live_streaming_holiday_season_theme,
  'live-streaming-old-hollywood-theme': live_streaming_old_hollywood_theme,
  'live-streaming-poinsettia-theme': live_streaming_poinsettia_theme,
  'live-streaming-festive-theme': live_streaming_festive_theme,
  'live-streaming-gradient-theme': live_streaming_gradient_theme,
  'live-streaming-starting-soon': live_streaming_starting_soon,
  'live-streaming-frame-overlay': live_streaming_frame_overlay,
  'live-streaming-qa': live_streaming_qa,
  'live-streaming-key-takeaway': live_streaming_key_takeaway,
  'live-streaming-valentine-theme': live_streaming_valentine_theme,
  'live-streaming-cooking-show-theme': live_streaming_cooking_show_theme,
  'live-streaming-gradient-business-theme': live_streaming_gradient_business_theme,
  'live-streaming-night-city-theme': live_streaming_night_city_theme,
  'live-streaming-fitness-theme': live_streaming_fitness_theme,
  'live-streaming-remote-work-theme': live_streaming_remote_work_theme,
  'live-streaming-medical-theme': live_streaming_medical_theme,
  'live-streaming-makeup-theme': live_streaming_makeup_theme,
  'live-streaming-interior-design-theme': live_streaming_interior_design_theme,
  'live-streaming-halloween-theme': live_streaming_halloween_theme,
  'live-streaming-thanksgiving-theme': live_streaming_thanksgiving_theme,
  'live-streaming-christmas-sweater-theme': live_streaming_christmas_sweater_theme,
  'ads-promo': ads_promo,
  'ads-promo-ads': ads_promo_ads,
  'use-cases-news': use_cases_news,
  'ads-promo-promo': ads_promo_promo,
  'ads-promo-testimonials': ads_promo_testimonials,
  'use-cases': use_cases,
  'use-cases-frame': use_cases_frame,
  'use-cases-memes': use_cases_memes,
  'use-cases-lyric': use_cases_lyric,
  'use-cases-recipe': use_cases_recipe,
  'use-cases-quotes': use_cases_quotes,
  'use-cases-collage': use_cases_collage,
  'use-cases-animated': use_cases_animated,
  'use-cases-tutorials': use_cases_tutorials,
  'use-cases-greeting': use_cases_greetings,
  'use-cases-countdown': use_cases_countdown,
  'use-cases-listicles': use_cases_listicles,
  'use-cases-slideshow': use_cases_slideshow,
  'use-cases-powerpoint': use_cases_powerpoint,
  'use-cases-intro-outro': use_cases_intro_outro,
  'use-cases-lower-third': use_cases_lower_third,
  'use-cases-travel-vlog': use_cases_travel_vlog,
  'use-cases-presentation': use_cases_presentation,
  'use-cases-product-demo': use_cases_product_demo,
  'use-cases-website-video': use_cases_website_video,
  'use-cases-special-offers': use_cases_special_offers,
  'use-cases-blog-promotion': use_cases_blog_promotion,
  'use-cases-event-promotion': use_cases_event_promotion,
  'use-cases-zoom-backgrounds': use_cases_zoom_backgrounds,
  'use-cases-background-video': use_cases_background_video,
  'use-cases-fun-social-posts': use_cases_fun_social_posts,
  'use-cases-restaurant-promo': use_cases_restaurant_promo,
  'social-media-trending-hashtags': social_media_trending_hashtags,
  'use-cases-podcast-promotion': use_cases_podcast_promotion,
  'use-cases-trailers': use_cases_trailers,
  'social-media': social_media,
  'social-media-twitter': social_media_twitter,
  'social-media-youtube': social_media_youtube,
  'social-media-stories': social_media_stories,
  'social-media-facebook': social_media_facebook,
  'social-media-linkedin': social_media_linkedin,
  'social-media-instagram': social_media_instagram,
  'social-media-pinterest': social_media_pinterest,
  'social-media-youtube-shorts': social_media_youtube_shorts,
  'social-media-tiktok': social_media_tiktok,
  'industry-food': industry_food,
  'industry-pets': industry_pets,
  'industry-music': industry_music,
  'industry-beauty': industry_beauty,
  'industry-travel': industry_travel,
  'industry-nature': industry_nature,
  'industry-fashion': industry_fashion,
  'industry-wedding': industry_wedding,
  'industry-business': industry_business,
  'industry-lifestyle': industry_lifestyle,
  'industry-marketing': industry_marketing,
  'industry-education': industry_education,
  'industry-video-game': industry_video_game,
  'industry-e-commerce': industry_e_commerce,
  'industry-healthcare': industry_healthcare,
  'industry-technology': industry_technology,
  'industry-real-estate': industry_real_estate,
  'industry-entertainment': industry_entertainment,
  'industry-art-and-culture': industry_art_and_culture,
  'industry-sports-and-fitness': industry_sports_and_fitness,
  'industry-architecture-and-design': industry_architecture_and_design,
  'holidays-season': holidays_season,
  'holidays-easter': holidays_easter,
  'holidays-birthday': holidays_birthday,
  'holidays-halloween': holidays_halloween,
  'holidays-christmas': holidays_christmas,
  'holidays-labor-day': holidays_labor_day,
  'holidays-mothers-day': holidays_mothers_day,
  'holidays-fathers-day': holidays_fathers_day,
  'holidays-observances': holidays_observances,
  'holidays-memorial-day': holidays_memorial_day,
  'holidays-thanksgiving': holidays_thanksgiving,
  'holidays-back-to-school': holidays_back_to_school,
  'holidays-valentines-day': holidays_valentines_day,
  'holidays-st-patricks-day': holidays_st_patricks_day,
  'holidays-independence-day': holidays_independence_day,
  'holidays-black-friday-cyber-monday': holidays_black_friday_cyber_monday,
  image,
  'image-thumbnail': image_thumbnail,
  'image-lower-third': image_lower_third,
  'image-meme': image_meme,
  'image-facebook-cover': image_facebook_cover,
  'image-quote': image_quote,
  'image-overlay': image_overlay
};

export default allPages;
